import React, {useContext} from "react";
import styled from "styled-components";
import Dropzone from "react-dropzone";
import { transparentize } from "polished";
import { TranslationContext } from "../../Providers/TranslationProvider";

const StyledDropZone = styled.div`
    border: 1px solid ${transparentize(0.8, "black")};
    width: 100%;
    border-radius: 6px;
    height: 200px;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
`;

const Content = styled.div`
    text-align: center;
`;

const Icon = styled.i`
    font-size: 2.5rem;
    color: #569184;
`;

const UploadField = props => {
    const {trans} = useContext(TranslationContext)
    return (
        <Dropzone
            multiple={props.multiple}
            onDrop={(acceptedFiles, rejectedFiles) =>
                props.onFileDrop(
                    acceptedFiles,
                    rejectedFiles,
                    props.scale ? props.scale: 300
                )
            }
        >
            {({ getRootProps, getInputProps, isDragActive }) => {
                return (
                    <StyledDropZone {...getRootProps()}>
                        
                        <input {...getInputProps()} />
                        {isDragActive ? (
                            <p>{trans('drop_files_here', true)}</p>
                        ) : (
                            <Content>
                                <Icon className="fas fa-file-upload" />
                                <p>
                                    {trans('drop_files_here', true)}
                                </p>
                                <button className="button">
                                {trans('select_files', true)}
                                </button>
                            </Content>
                        )}
                    </StyledDropZone>
                );
            }}
        </Dropzone>
    );
};

export default UploadField;
